import { assertString } from '../../../utils';

var splitFullName = value => {
  assertString(value);
  var firstWhiteSpace = value.indexOf(' ');
  var splitAt = firstWhiteSpace > -1 ? firstWhiteSpace : value.length;
  var first = value.substr(0, splitAt);
  var last = value.substr(splitAt + 1);
  return {
    firstName: {
      value: first
    },
    lastName: {
      value: last
    }
  };
};

export { splitFullName };